var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveListingUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60039 16.4V6H2.40039V17.6H18.6004V6H17.4004V16.4H3.60039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5903 0.302734L20.3141 6.27086L19.6864 7.29359L10.5685 1.69733C9.16544 2.50958 7.3367 3.6548 5.66126 4.70401C5.51038 4.7985 5.36074 4.89221 5.21276 4.98483C4.25964 5.58139 3.3756 6.13264 2.68209 6.5491C2.33566 6.75714 2.03177 6.93455 1.78793 7.0683C1.56436 7.19093 1.33769 7.3075 1.17231 7.35702L0.828125 6.20744C0.830215 6.20669 0.862189 6.19533 0.936691 6.15937C1.00763 6.12513 1.09893 6.07756 1.21084 6.01618C1.43439 5.89356 1.72278 5.72543 2.06431 5.52034C2.74673 5.11054 3.62137 4.56521 4.5761 3.96764C4.72569 3.87402 4.87724 3.77911 5.03029 3.68326C6.82327 2.5604 8.82251 1.30837 10.2821 0.478095L10.5903 0.302734Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8H7V7H14V8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 11H7V10H14V11Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14H7V13H10V14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveListingUnit);
export default __webpack_public_path__ + "static/media/active-listing-unit.97aa9acc.svg";
export { ForwardRef as ReactComponent };